/* eslint-disable react/prop-types */
import { createContext, useState, useContext, useEffect, useRef } from 'react';

// import { getGridProductsById } from 'actions/products';
import { useI18n } from './i18n';

import type { TProductData } from 'types/product-list';

type TProductsGridContext = {
  productData: Record<string, TProductData>;
  getSingleProductData: (productId: string, brandProductId: string, defaultProduct: TProductData) => TProductData;
  addProductsData: (newProducts: TProductData[]) => void;
};

const ProductsGridContext = createContext<TProductsGridContext | undefined>(undefined);

type TProductsGridContextProps = {
  children: React.ReactNode;
  data: TProductData[];
  squareImg: boolean;
};

export function ProductsGridContextProvider({ children, data, squareImg }: TProductsGridContextProps) {
  const { locale } = useI18n();
  // const loadingColors = useRef(true);
  // Inicializo el ref a null y lo relleno debajo para evitar calcularlo en cada render https://react.dev/reference/react/useRef#avoiding-recreating-the-ref-contents
  const productData = useRef<null | Record<string, TProductData>>(null);

  if (productData.current === null) {
    productData.current =
      Array.isArray(data) ?
        data.reduce((acc, item) => {
          acc[item.id] = { ...item, item };
          return acc;
        }, {})
      : {};
  }

  const addProductsData: TProductsGridContext['addProductsData'] = (newProducts) => {
    newProducts.forEach((item) => {
      if (item.id in productData.current) {
        return;
      }
      productData.current[item.id] = { ...item, item };
    });
  };

  // si existe el producto clicado en brand en el objecto devolvemos ese, si no existe devolvemos el original
  const getSingleProductData: TProductsGridContext['getSingleProductData'] = (productId, brandProductId, defaultProduct: TProductData) => {
    return productData.current[brandProductId] ?? productData.current[productId] ?? defaultProduct;
  };

  // useEffect(() => {
  //   const handleGetColors = async () => {
  //     const realTargetId = data[0].targetId;
  //     const colorIDs = Array.from(
  //       new Set(
  //         data
  //           .filter((item) => item.colors)
  //           .map((item) => item.colors)
  //           .flatMap((item) => item)
  //           .map((item) => item.id)
  //           .filter((item) => !Object.keys(productData).includes(item)),
  //       ),
  //     );

  //     const productResponse = await getGridProductsById({ profile: locale, target: realTargetId, skus: colorIDs, square: squareImg });

  //     if (productResponse) {
  //       productResponse
  //         .filter((productItem) => !(productItem.id in productData))
  //         .forEach((productItem) => {
  //           addProductData(productItem.id, { ...productItem, item: productItem });
  //         });
  //     }
  //   };

  //   if (loadingColors.current) {
  //     loadingColors.current = false;
  //     handleGetColors();
  //   }
  // }, [loadingColors.current]);

  // useEffect(() => {
  //   loadingColors.current = true;
  // }, [data]);

  return (
    <ProductsGridContext.Provider
      value={{
        productData: productData.current,
        getSingleProductData,
        addProductsData,
      }}
    >
      {children}
    </ProductsGridContext.Provider>
  );
}

export function useProductsGrid() {
  const context = useContext(ProductsGridContext);
  if (context === undefined) {
    throw new Error('useProductsGrid must be used within a ProductsGridContextProvider');
  }
  return context;
}
